import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';
import BadgeBase from '@components/common/core/DataDisplay/Badge';
import CustomTooltipBase from '@components/common/core/Utils/CustomTooltip';

export const RevenueBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RevenueTypeBadge = styled(BadgeBase)``;

export const RevenueTypeText = styled(TextBase)`
  margin-left: 5px;
  color: inherit;
`;

export const RevenueType = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RevenueValueNeutro = styled(TextBase)`
  color: #00f2a1;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const RevenueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Tooltip = styled(CustomTooltipBase)``;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const DescriptionText = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
  font-size: 0.875rem;
`;

export const ValueText = styled(TextBase)`
  font-size: 0.875rem;
`;
